import { $ } from "@/common/Axios";

export default {
  /**
   * 打卡异常
   */
  abnormalPunching: {
    /*
     * 记录异常
     * address 地址 (string query )
     * attendanceId 考勤id (integer query )
     * id  (integer query )
     * latitude 纬度 (number query )
     * longitude 经度 (number query )
     * schoolRollId 学生id (integer query )
     * type 异常类型 (string query )
     */
    post: (p, c) => $.post("/api/zms/attendance/abnormalPunching", p, c),
  },

  /**
   * 考勤
   */
  attendance_clear: {
    /*
     * 清除考勤
     * ids 考勤id (array query required)
     */
    delete: (p, c) => $.delete("/api/zms/attendance/attendance/clear", p, c),
  },
  attendance_getDormitoryInfo: {
    /*
     * 获取当天到寝考勤信息
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendance/getDormitoryInfo", p, c),
  },
  attendance_listByAttendanceCourseId: {
    /*
     * 根据到课考勤id获取考勤记录
     * attendanceCourseId 到课考勤id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendance/listByAttendanceCourseId", p, c),
  },
  attendance_listForCourse: {
    /*
     * 到课考勤列表
     */
    get: (p, c) => $.get("/api/zms/attendance/attendance/listForCourse", p, c),
  },
  attendance_listForDormitory: {
    /*
     * 到寝考勤列表
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendance/listForDormitory", p, c),
  },
  attendance_listForSiteCourse: {
    /*
     * 学校到课考勤列表
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendance/listForSiteCourse", p, c),
  },
  attendance_listTodaySiteCourse: {
    /*
     * 获取学校课表考勤列表
     * planId 教学计划id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendance/listTodaySiteCourse", p, c),
  },
  attendance_open: {
    /*
     * 开启考勤
     * attendanceCourseId 到课考勤id (integer query )
     * type 类型：到课、到寝 (string query required)
     */
    post: (p, c) => $.post("/api/zms/attendance/attendance/open", p, c),
  },
  attendance_openSiteCourse: {
    /*
     * 开启学校课表考勤
     * planId 教学计划id (integer query required)
     * timeType 类型：上午、下午、晚上 (string query required)
     */
    post: (p, c) =>
      $.post("/api/zms/attendance/attendance/openSiteCourse", p, c),
  },

  /**
   * 到课考勤
   */
  attendanceCourse_applyEntrust: {
    /*
     * 申请委托
     * attendanceDate 考勤日期 (string query )
     * classRoomId 班级id (integer query )
     * entrustId 委托老师id (integer query required)
     * id 到课考勤 (integer query required)
     * timeType 时间类型：上午首次。。。 (string query )
     */
    post: (p, c) =>
      $.post("/api/zms/attendance/attendanceCourse/applyEntrust", p, c),
  },
  attendanceCourse_countForEntrust: {
    /*
     * 委托考勤数量
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceCourse/countForEntrust", p, c),
  },
  attendanceCourse_init: {
    /*
     * 当天到课考勤初始化（测试阶段用，后续使用定时任务）
     * classRoomId 班级id (integer query required)
     */
    post: (p, c) => $.post("/api/zms/attendance/attendanceCourse/init", p, c),
  },
  attendanceCourse_listAttendanceDateForEntrust: {
    /*
     * 委托考勤日期列表
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceCourse/listAttendanceDateForEntrust",
        p,
        c
      ),
  },
  attendanceCourse_listForEntrust: {
    /*
     * 委托考勤列表
     * attendanceDate 考勤日期 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceCourse/listForEntrust", p, c),
  },
  attendanceCourse_listForStudent: {
    /*
     * 学生考勤列表
     * attendanceDate 考勤日期 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceCourse/listForStudent", p, c),
  },
  attendanceCourse_listForStudentByHeaderTeacher: {
    /*
     * 学生考勤列表
     * attendanceDate 考勤日期 (string query )
     * classRoomId 班级id (integer query )
     * schoolRollId 学生id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceCourse/listForStudentByHeaderTeacher",
        p,
        c
      ),
  },
  attendanceCourse_listTodayForHeaderTeacher: {
    /*
     * 班主任当天考勤列表(含带班老师)
     * attendanceDate 考勤日期 (string query )
     * classRoomId 班级id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceCourse/listTodayForHeaderTeacher",
        p,
        c
      ),
  },

  /**
   * 考勤记录
   */
  attendanceRecord: {
    /*
     * 删除考勤记录
     * ids 考勤记录id (array query )
     */
    delete: (p, c) => $.delete("/api/zms/attendance/attendanceRecord", p, c),
  },
  attendanceRecord_changeStatus: {
    /*
     * 修改考勤状态(学工操作)
     * id 考勤记录id (integer query required)
     * status 考勤状态：已打卡、请假 (string query required)
     * type 打卡类型：如果是到课，则为手动、蓝牙，如果是到寝，则为手动、指纹 (string query required)
     */
    put: (p, c) =>
      $.put("/api/zms/attendance/attendanceRecord/changeStatus", p, c),
  },
  attendanceRecord_changeType: {
    /*
     * 修改考勤类型
     * id 考勤记录id (integer query )
     * type 考勤类型 (string query )
     */
    put: (p, c) =>
      $.put("/api/zms/attendance/attendanceRecord/changeType", p, c),
  },
  attendanceRecord_exportForCourse: {
    /*
     * 到课考勤记录列表导出
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/exportForCourse", p, c),
  },
  attendanceRecord_exportForCourseByDomain: {
    /*
     * 到课考勤记录列表导出-根据学校域名
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/exportForCourseByDomain",
        p,
        c
      ),
  },
  attendanceRecord_exportForDormitory: {
    /*
     * 到寝考勤记录列表导出
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/exportForDormitory", p, c),
  },
  attendanceRecord_exportForSiteCourse: {
    /*
     * 学校课表到课考勤记录列表导出
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/exportForSiteCourse", p, c),
  },
  attendanceRecord_exportStaticsForSiteCourse: {
    /*
     * 导出学校课表考勤统计信息
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/exportStaticsForSiteCourse",
        p,
        c
      ),
  },
  attendanceRecord_exportStudentAttendanceInfo: {
    /*
     * 导出学生考勤情况列表
     * batch 批次 (string query )
     * classRoomId 班级 (integer query )
     * end 结束时间 (string query required)
     * siteId 学校 (integer query )
     * start 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/exportStudentAttendanceInfo",
        p,
        c
      ),
  },
  attendanceRecord_getAttendanceCase: {
    /*
     * 获取考勤情况（学生端）
     * end 结束时间 (string query )
     * schoolRollId 合同id (integer query )
     * start 开始时间 (string query )
     * termId 学期 (integer query )
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/getAttendanceCase", p, c),
  },
  attendanceRecord_getDormitoryByStudent: {
    /*
     * 根据学生获取到寝考勤记录
     * attendanceDate 考勤日期 (string query required)
     * schoolRollId 合同id (integer query )
     * siteId siteId (integer query )
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/getDormitoryByStudent", p, c),
  },
  attendanceRecord_listAllAttendanceStaticForClassRoom: {
    /*
     * 所有考勤统计列表（含到课、到寝）（班级维度）（总监）
     * classRoomIds 班级id (array query required)
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listAllAttendanceStaticForClassRoom",
        p,
        c
      ),
  },
  attendanceRecord_listAttendanceStaticForClassRoom: {
    /*
     * 考勤统计列表（班级维度）（总监和班主任通用）
     * classRoomIds 班级id (array query required)
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listAttendanceStaticForClassRoom",
        p,
        c
      ),
  },
  attendanceRecord_listAttendanceStaticForHeaderTeacher: {
    /*
     * 考勤统计列表（班主任维度）（总监和班主任通用）
     * classRoomIds 班级id (array query required)
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listAttendanceStaticForHeaderTeacher",
        p,
        c
      ),
  },
  attendanceRecord_listAttendanceStaticForSite: {
    /*
     * 考勤统计列表（学校维度）（公司层面使用）
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listAttendanceStaticForSite",
        p,
        c
      ),
  },
  attendanceRecord_listAttendanceStaticForStudent: {
    /*
     * 考勤统计列表（学生维度）
     * classRoomId 班级id (integer query required)
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listAttendanceStaticForStudent",
        p,
        c
      ),
  },
  attendanceRecord_listByAttendance: {
    /*
     * 根据考勤id获取考勤记录
     * attendanceId 考勤id (integer query )
     * attendanceIds 考勤id (array query )
     * classRoomIds 班级id (array query )
     * end 结束时间 (string query )
     * gender 性别：男、女 (string query )
     * halls 宿舍楼 (string query )
     * roomNum 寝室 (string query )
     * start 开始时间 (string query )
     * statuses 状态 (array query )
     * type 类型 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/listByAttendance", p, c),
  },
  attendanceRecord_listClassRoomCourseByTeacher: {
    /*
     * 讲师查看到课考勤情况（班级）
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * siteId 学校id (integer query required)
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listClassRoomCourseByTeacher",
        p,
        c
      ),
  },
  attendanceRecord_listCourseAttendanceStaticForTeacher: {
    /*
     * 到课考勤统计列表（讲师维度）（总监和班主任通用）
     * classRoomIds 班级id (array query required)
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listCourseAttendanceStaticForTeacher",
        p,
        c
      ),
  },
  attendanceRecord_listDormitoryBuildingByAttendance: {
    /*
     * 根据考勤id获取宿舍楼列表
     * attendanceIds 考勤id (array query required)
     * gender 性别：男，女 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listDormitoryBuildingByAttendance",
        p,
        c
      ),
  },
  attendanceRecord_listDormitoryByAttendance: {
    /*
     * 根据考勤id获取寝室考勤情况
     * attendanceIds 考勤id (array query required)
     * gender 性别：男，女 (string query required)
     * halls 宿舍楼 (string query )
     * status 是否已经打卡：是、否 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listDormitoryByAttendance",
        p,
        c
      ),
  },
  attendanceRecord_listDormitoryByStudent: {
    /*
     * 根据学生获取到寝考勤记录列表
     * end 结束时间 (string query required)
     * schoolRollId 合同id (integer query )
     * start 开始时间 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listDormitoryByStudent",
        p,
        c
      ),
  },
  attendanceRecord_listForCourse: {
    /*
     * 到课考勤记录列表
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/listForCourse", p, c),
  },
  attendanceRecord_listForCourseByDomain: {
    /*
     * 到课考勤记录列表-根据学校域名
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/listForCourseByDomain", p, c),
  },
  attendanceRecord_listForDormitory: {
    /*
     * 到寝考勤记录列表
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/listForDormitory", p, c),
  },
  attendanceRecord_listForSiteCourse: {
    /*
     * 学校课表到课考勤记录列表
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/listForSiteCourse", p, c),
  },
  attendanceRecord_listRecordByStudent: {
    /*
     * 根据学生获取考勤记录列表
     * end 结束时间 (string query )
     * schoolRollId 合同id (integer query )
     * start 开始时间 (string query )
     * statuses 考勤状态 (array query )
     * type 类型：到课、到寝 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceRecord/listRecordByStudent", p, c),
  },
  attendanceRecord_listSiteAttendanceStaticForClassRoom: {
    /*
     * 学校课表考勤统计列表（班级维度）
     * batches 批次 (array query )
     * end 结束时间 (string query )
     * siteId 学校id (integer query required)
     * start 开始时间 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listSiteAttendanceStaticForClassRoom",
        p,
        c
      ),
  },
  attendanceRecord_listSiteAttendanceStaticForHeaderTeacher: {
    /*
     * 学校课表考勤统计列表（班主任维度）
     * batches 批次 (array query )
     * end 结束时间 (string query )
     * siteId 学校id (integer query required)
     * start 开始时间 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listSiteAttendanceStaticForHeaderTeacher",
        p,
        c
      ),
  },
  attendanceRecord_listSiteAttendanceStaticForSite: {
    /*
     * 学校课表考勤统计列表（学校维度）
     * batches 批次 (array query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listSiteAttendanceStaticForSite",
        p,
        c
      ),
  },
  attendanceRecord_listSiteCourseByTeacher: {
    /*
     * 讲师查看到课考勤情况（学校）
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listSiteCourseByTeacher",
        p,
        c
      ),
  },
  attendanceRecord_listStaticsForSiteCourse: {
    /*
     * 获取学校课表考勤统计信息
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listStaticsForSiteCourse",
        p,
        c
      ),
  },
  attendanceRecord_listStudentCourseByTeacher: {
    /*
     * 讲师查看到课考勤情况（学生）
     * classRoomId 班级id (integer query required)
     * employStatus 是否内部员工 (string query )
     * end 结束时间 (string query )
     * start 开始时间 (string query )
     * timeType 考勤时间：首次、灵活 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listStudentCourseByTeacher",
        p,
        c
      ),
  },
  attendanceRecord_listUnfinishHeaderTeacherInfoForSiteCourse: {
    /*
     * 获取血校课表考勤未完成情况(班主任)
     * attendanceId 考勤id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listUnfinishHeaderTeacherInfoForSiteCourse",
        p,
        c
      ),
  },
  attendanceRecord_listUnfinishRecordForSiteCourseByHeaderTeacher: {
    /*
     * 获取未完成学校课表考勤记录列表(班主任)
     * attendanceId 考勤id (integer query required)
     * headerTeacherId 班主任id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceRecord/listUnfinishRecordForSiteCourseByHeaderTeacher",
        p,
        c
      ),
  },
  attendanceRecord_punchCourse: {
    /*
     * 到课打卡(班主任操作)
     * attach 附件 (string query )
     * attendanceId 考勤id (integer query required)
     * schoolRollId 合同id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/attendance/attendanceRecord/punchCourse", p, c),
  },
  attendanceRecord_punchCourseByStudent: {
    /*
     * 到课打卡(学生操作)
     * attendanceId 考勤id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/attendance/attendanceRecord/punchCourseByStudent", p, c),
  },
  attendanceRecord_punchDormitory: {
    /*
     * 到寝打卡(班主任操作)
     * resultType 结果类型：正常、晚归 (string query required)
     * schoolRollIds 合同ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/zms/attendance/attendanceRecord/punchDormitory", p, c),
  },
  attendanceRecord_uploadChangeStatus: {
    /*
     * 批量修改考勤状态
     * attendanceId 考勤id (integer query required)
     * file file (file formData required)
     * ignoreErr 是否忽略报错信息 (string query required)
     * status 考勤状态：打卡、请假 (string query required)
     * type 打卡类型：如果是到课，则为手动、蓝牙，如果是到寝，则为手动、指纹 (string query required)
     */
    post: (p, c) =>
      $.post("/api/zms/attendance/attendanceRecord/uploadChangeStatus", p, c),
  },
  attendanceRecord_uploadRemoveDormitory: {
    /*
     * 导入删除到寝考勤
     * attendanceDate 考勤日期 (string query required)
     * file file (file formData required)
     * siteId 学校id (integer query required)
     */
    post: (p, c) =>
      $.post(
        "/api/zms/attendance/attendanceRecord/uploadRemoveDormitory",
        p,
        c
      ),
  },
  attendanceRecord_uploadRemoveRecord: {
    /*
     * 批量清除考勤记录
     * attendanceId 考勤id (integer query required)
     * file file (file formData required)
     * ignoreErr 是否忽略报错信息 (string query required)
     */
    post: (p, c) =>
      $.post("/api/zms/attendance/attendanceRecord/uploadRemoveRecord", p, c),
  },
  attendanceRecord_withdrawCourse: {
    /*
     * 撤销到课打卡(班主任操作)
     * attendanceId 考勤id (integer query required)
     * schoolRollId 合同id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/zms/attendance/attendanceRecord/withdrawCourse", p, c),
  },
  attendanceRecord_withdrawPunchDormitory: {
    /*
     * 撤销到寝打卡(班主任操作)
     * id 考勤记录 (integer query required)
     */
    put: (p, c) =>
      $.put(
        "/api/zms/attendance/attendanceRecord/withdrawPunchDormitory",
        p,
        c
      ),
  },

  /**
   * 考勤排班
   */
  attendanceWorkforce: {
    /*
     * 添加
     * adminId 考勤负责人 (integer query )
     * attendanceDate 考勤日期 (string query )
     * batch 批次 (string query )
     * halls 宿舍楼 (string query )
     * id  (integer query )
     * siteId 学校id (integer query )
     * type 类型：到寝 (string query )
     */
    post: (p, c) => $.post("/api/zms/attendance/attendanceWorkforce", p, c),

    /*
     * 删除
     * ids id (array query required)
     */
    delete: (p, c) => $.delete("/api/zms/attendance/attendanceWorkforce", p, c),
  },
  attendanceWorkforce_exportForDormitory: {
    /*
     * 到寝考勤排班列表导出
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceWorkforce/exportForDormitory", p, c),
  },
  attendanceWorkforce_listDormitoryBuilding: {
    /*
     * 宿舍楼列表
     * attendanceDate 考勤日期 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/attendance/attendanceWorkforce/listDormitoryBuilding",
        p,
        c
      ),
  },
  attendanceWorkforce_listForDormitory: {
    /*
     * 到寝考勤排班列表
     */
    get: (p, c) =>
      $.get("/api/zms/attendance/attendanceWorkforce/listForDormitory", p, c),
  },
  attendanceWorkforce_uploadForDormitory: {
    /*
     * 导入到寝考勤排班
     * file file (file formData required)
     */
    post: (p, c) =>
      $.post(
        "/api/zms/attendance/attendanceWorkforce/uploadForDormitory",
        p,
        c
      ),
  },
};
